import React from 'react'
import { Routes, Route, useSearchParams } from 'react-router-dom'
import MyAccountPage from 'pages/MyAccount'
import CartPage from 'pages/Cart'
import ScrollToHash from 'components/ScrollToHash'
import PublicRoutes from 'routers/PublicRoutes'
import PrivateRoutes from 'routers/PrivateRoutes'
import QuoteListPage from 'pages/QuoteList'
import QuotePage from 'pages/Quote'
import CheckoutPage from 'pages/Checkout'
import SearchPage from 'pages/Search'
import QuickOrderPage from 'pages/QuickOrder'

const AppRoutes = () => {
  const [searchParams] = useSearchParams()
  const keyword = searchParams.get('keyword') || ''

  return (
    <>
      <ScrollToHash />
      <Routes>
        <Route path='/*' element={<PublicRoutes />} />

        <Route element={<PrivateRoutes />}>
          <Route path='/my-account' element={<MyAccountPage />} />
          <Route path='/cart' element={<CartPage />} />
          <Route path='/quotes' element={<QuoteListPage />} />
          <Route path='/quotes/:quoteId' element={<QuotePage />} />
          <Route path='/checkout' element={<CheckoutPage />} />
          <Route path='/search' element={<SearchPage keyword={keyword} />} />
          <Route path='/quick-order' element={<QuickOrderPage />} />
        </Route>
      </Routes>
    </>
  )
}

export default AppRoutes
